"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function StringArrayRotateFunctionTemplate() {
    return `
        (function (array, {timesName}) {
            const {whileFunctionName} = function (times) {
                while (--times) {
                    array['push'](array['shift']());
                }
            };
            
            {code}
        })({stringArrayName}, 0x{stringArrayRotationAmount});
    `;
}
exports.StringArrayRotateFunctionTemplate = StringArrayRotateFunctionTemplate;
